import script from "./CircleAsk.vue?vue&type=script&setup=true&lang=js"
export * from "./CircleAsk.vue?vue&type=script&setup=true&lang=js"

import "./CircleAsk.vue?vue&type=style&index=0&id=92c2ea1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92c2ea1a"]])

export default __exports__